import { render, staticRenderFns } from "./DirectionItem.vue?vue&type=template&id=8c4bd01c&scoped=true&"
import script from "./DirectionItem.vue?vue&type=script&lang=js&"
export * from "./DirectionItem.vue?vue&type=script&lang=js&"
import style0 from "./DirectionItem.vue?vue&type=style&index=0&id=8c4bd01c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4bd01c",
  null
  
)

export default component.exports